import { io } from 'socket.io-client';
import API_CONFIG from '../config/api.config';

let socket = null;

/**
 * Resolve Socket.IO host. Prefer explicit API base; in CRA dev fall back to proxy target.
 */
export function getEventsSocketUrl() {
  if (API_CONFIG.BASE_URL) {
    return API_CONFIG.BASE_URL.replace(/\/$/, '');
  }
  return (
    process.env.REACT_APP_WS_URL ||
    process.env.REACT_APP_API_PROXY_TARGET ||
    process.env.REACT_APP_PROXY_TARGET ||
    window.location.origin
  ).replace(/\/$/, '');
}

function readOrgIdFromToken(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.organizationId || payload.orgId || null;
  } catch {
    return null;
  }
}

function joinOrganizationRoom(activeSocket, token) {
  const organizationId = readOrgIdFromToken(token);
  if (!organizationId) return;
  activeSocket.emit('join-organization', { organizationId });
}

/**
 * Singleton Socket.IO client for `/events` (JWT auth + org room).
 */
export function getEventsSocket() {
  const token = localStorage.getItem(API_CONFIG.TOKEN.STORAGE_KEY);
  if (!token) {
    return null;
  }
  if (socket) {
    socket.auth = { token };
    if (!socket.connected && !socket.active) {
      socket.connect();
    }
    return socket;
  }
  socket = io(`${getEventsSocketUrl()}/events`, {
    auth: { token },
    transports: ['websocket', 'polling'],
    autoConnect: true,
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10000,
  });
  socket.on('connect', () => {
    joinOrganizationRoom(socket, token);
  });
  return socket;
}

export function disconnectEventsSocket() {
  if (!socket) return;
  socket.removeAllListeners();
  socket.disconnect();
  socket = null;
}
